export const MAX_PLAYER_LEADERBOARD_LIMIT = 1000;
export const MAX_FACTION_LEADERBOARD_LIMIT = 500;
export const LEADERBOARD_SECTIONS = {
  FACTION_BOSS: 'faction-boss-section',
  FACTION_FEUD: 'faction-feud-section',
};
